export default __webpack_public_path__ + "static/media/echosystem.59dbc821.png";